module.exports = __webpack_public_path__ + "static/media/lamina18actividad.f5ed9705.png";